/* eslint-disable arrow-body-style */
import firebase from 'firebase';
import { useAtom } from 'jotai';
import { auth } from './firebase';
import { userRecordAtom } from '../state/atoms';

// ----------------------------------------------------------------------

function useAuthService() {
  const [, setUserRecord] = useAtom(userRecordAtom);

  const createUserWithEmailAndPassword = (email, password) => auth().createUserWithEmailAndPassword(email, password);

  const createAccount = async (email, password) => {
    const userCredential = await createUserWithEmailAndPassword(email, password);
    return userCredential;
  };

  const signIn = (email, password) =>
    firebase
      .auth()
      .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(() => {
        return auth()
          .signInWithEmailAndPassword(email, password)
          .then((res) => res);
      });

  const resetPassword = (email) =>
    auth()
      .sendPasswordResetEmail(email)
      .then((res) => res);

  const signOut = () => {
    // setUser(null);
    setUserRecord(null);
    return auth().signOut();
  };

  const sendVerificationEmail = (userId) =>
    auth()
      .currentUser.sendEmailVerification({
        url: `${window.location.origin}/auth/verify-email?userid=${userId}`,
        handleCodeInApp: true,
      })
      .catch((error) => {
        console.error('Error sending verification email: ', error);
        throw error;
      });

  return { createAccount, signIn, resetPassword, signOut, sendVerificationEmail, createUserWithEmailAndPassword };
}

export default useAuthService;
